export default __webpack_public_path__ + "static/media/how-to-install-nodejs.76ecc54f.md";